import arrayReduce from 'fast-loops/lib/arrayReduce';

export default function extractPassThroughProps(passThrough, ruleProps) {
  return arrayReduce(passThrough, function (output, property) {
    if (ruleProps.hasOwnProperty(property)) {
      output[property] = ruleProps[property];
    }

    return output;
  }, {});
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-bindings/es/extractPassThroughProps.js
// module id = 1149
// module chunks = 0